import { useContext, createContext } from 'react'
import { initialState } from '../reducer/pickingReportReducer'
import { actionTypes } from '../types/actionTypes'
import { ReducerPickingReport } from '../types/reducerTypes'

interface PickingReportContext {
  state: ReducerPickingReport
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
export const PickingReportContext = createContext<PickingReportContext>({
  state: initialState,
  dispatch: () => {}
})

// Se crea un custom hook para validar que nuestro contexto no contenta una instancia indefinida
// y una vez se valide que si contiene una instancia, lo retornamos para su uso posterior

export const usePickingReport = () => {
  const context = useContext(PickingReportContext)
  if (context === undefined) {
    throw new Error('usePickingReport must be used with a Provider')
  }

  return context
}
